// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZVhe","content":"styles_content__3ZKEp"};